var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.924 53.358c.625 0 1.118-.273 1.48-.82l13.842-21.797c.127-.205.22-.39.278-.556a1.66 1.66 0 0 0 .088-.528c0-.4-.122-.722-.366-.967-.244-.244-.566-.366-.967-.366-.293 0-.532.059-.718.176-.185.107-.366.298-.541.571L36.864 50.033l-6.826-8.935c-.352-.479-.771-.718-1.26-.718-.41 0-.747.132-1.01.395-.264.254-.396.581-.396.982 0 .176.034.356.103.542.068.176.175.351.322.527L35.4 52.51c.44.566.948.85 1.524.85Z",
    fill: "#fff"
  })));
};

export default SvgTick;